import { render, staticRenderFns } from "./TraxAccountGroupEditMembers.vue?vue&type=template&id=347ffeaa"
import script from "./TraxAccountGroupEditMembers.vue?vue&type=script&lang=js"
export * from "./TraxAccountGroupEditMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports